import * as React from 'react'

import { Site } from '@envato/foundation-types'

import { config } from '../../../../common/config'
import NextGenImageWrapper from '../../nextGenImageWrapper'
import SeoHeadings from '../../seoHeadings/seoHeadings'

import * as styles from './searchHeaderBlock.module.css'
import * as seoHeadingsStyles from '../../../components/seoHeadings/themes/homepage.newdesign.module.css'

interface IProps {
  title?: string
  currentSite: Site
}

const SearchHeaderBlock: React.SFC<IProps> = ({
  title,
  children,
  currentSite
}) => {
  const IMG_URL_DESKTOP = `${config.assets.PUBLIC_PATH}/images/home-page/new-design/${currentSite}/search-header-desktop-1588727016186`
  const IMG_URL_MOBILE = `${config.assets.PUBLIC_PATH}/images/home-page/new-design/${currentSite}/search-header-mobile-1588727016186`

  return (
    <section className={styles.root}>
      <div className={styles.wrapper}>
        <div className={styles.autosuggestWrapper}>
          <div className={styles.seoHeader}>
            <SeoHeadings
              TagName="h1"
              heading={
                title || 'Discover thousands of web themes and templates'
              }
              subHeading=""
              styles={seoHeadingsStyles}
            />
          </div>
          {children}
        </div>
        <div className={styles.imageWrapper}>
          <NextGenImageWrapper>
            <source
              srcSet={`${IMG_URL_DESKTOP}.webp`}
              media="(min-width: 960px)"
            />
            <img
              src={`${IMG_URL_MOBILE}.webp`}
              alt="image of item previews"
              className={styles.image}
            />
          </NextGenImageWrapper>
        </div>
      </div>
    </section>
  )
}

export default SearchHeaderBlock
